var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAlertTriangle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.0909L7 0L14 12.0909H0ZM1.65455 11.1364H12.3455L7 1.90909L1.65455 11.1364ZM7.06642 10.2295C7.20244 10.2295 7.31553 10.1835 7.40568 10.0915C7.49583 9.99952 7.54091 9.8855 7.54091 9.74949C7.54091 9.61347 7.49491 9.50038 7.4029 9.41023C7.31088 9.32008 7.19686 9.275 7.06085 9.275C6.92483 9.275 6.81174 9.321 6.72159 9.41301C6.63144 9.50503 6.58636 9.61904 6.58636 9.75506C6.58636 9.89108 6.63237 10.0042 6.72437 10.0943C6.81639 10.1845 6.93041 10.2295 7.06642 10.2295ZM6.58636 8.46364H7.54091V4.9H6.58636V8.46364Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertTriangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AlertTriangle.7660c0fb.svg";
export { ForwardRef as ReactComponent };